// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Yzda"};


//////////////////
// WEBPACK FOOTER
// ./app/components/no-user-posts/no-user-posts.scss
// module id = 1779
// module chunks = 0